import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { PasswordSimpleField } from 'components/FormFieldsSimple/PasswordSimpleField';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class PasswordField extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    label: PropTypes.string,
  };

  static defaultProps = {
    label: 'Password:',
  };

  render() {
    const { input, label, autoComplete = 'off', testId } = this.props;

    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <PasswordSimpleField
          label={label}
          onFocus={input.onFocus}
          onChange={(value) => input.onChange(value)}
          onBlur={input.onBlur}
          value={input.value}
          autoComplete={autoComplete}
          testId={testId}
        />
      </ReduxFormElementWrapper>
    );
  }
}
